import { memo } from "react";
import { Box, Typography, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../../contexts/GlobalState';
import { useCommonStyles } from '../../styles/GenericStyle';

interface ArchivedDataHeaderProps {
    onBackClick?: () => void;
    showFullHeader?: boolean;
    ageLabel?: string;
}

function ArchivedDataHeader({ onBackClick, showFullHeader, ageLabel = "Older than 6 months" }: ArchivedDataHeaderProps) {
    const classes = useCommonStyles();
    const navigate = useNavigate();
    const { state, setIsArchived } = useGlobalState();

    const handleArchiveToggle = () => {
        if (onBackClick) {
            onBackClick();
        } else {
            setIsArchived(false);
            navigate('/splot');
        }
    };

    const displayFullHeader = showFullHeader ?? state.isArchived;

    if (!displayFullHeader) {
        return null;
    }

    return (
        <Box sx={{ mb: 2 }}>
            {/* Back link */}
            <Typography
                component="span"
                sx={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', mb: 1 }}
                className={classes.labelNoto16Bold700}
                onClick={handleArchiveToggle}
            >
                <ArrowBackIcon sx={{ verticalAlign: 'middle', transform: 'scaleX(1.3)', transformOrigin: 'center left', mr: 0.5, fontSize: '1.1rem' }} />
                <Typography component="span" className={classes.labelNoto20Bold600}>Back</Typography>
            </Typography>

            {/* Title row */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                <Typography component="h1" className={classes.labelNoto36Bold700} sx={{ letterSpacing: 0.4 }}>
                    Archived Data
                </Typography>
                <Chip
                    label={ageLabel}
                    size="small"
                    sx={{
                        backgroundColor: '#4B5563',
                        color: '#FFFFFF',
                        fontSize: '13px',
                        fontWeight: 500,
                        height: '28px',
                        borderRadius: '999px',
                        '& .MuiChip-label': { px: 1.5 },
                    }}
                />
            </Box>
        </Box>
    );
}

export default memo(ArchivedDataHeader);
